import styled, { css } from 'styled-components';

export const LanguagesList = styled.ul`
    justify-content: center;
    align-items: center;
    list-style: none;
    margin: 0 auto;
    padding: 0;
    transition: width .2s ease;
    transition-delay: .3s;
`;

export const Language = styled.li`
    margin: 1rem .25rem;
`;

export const SelectLanguageButton = styled.button<{ active?: boolean }>`
    padding: 0;
    border: none;
    background-color: transparent;
    filter: grayscale(100%);
    transition: filter .4s;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    margin-left: 1rem;
    &:hover {
        filter: none;
    }

    ${({ active }) => active && css`
        filter: none;
    `};

    svg {
        width: 2rem;
        height: 2rem;
    }
`;
